module.exports = __webpack_public_path__ + "img/icon9@2x.8830e084.png";